<template>
  <div class="green lighten-4">
    <v-container style="max-width: 1800px">
      <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/reports/market/invoice`"
        active-class="white--text primary"
        outlined
        elevation="0"
        >{{ $t('payment.unpaid_payment_list') }}</v-btn
      >
      <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/reports/market/occupancyrate`"
        active-class="white--text primary"
        outlined
        elevation="0"
        >{{ $t('area.renting_rate') }}</v-btn
      >
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    type: String
  }
};
</script>

<style lang="scss" scoped>
.tool-bar{
  background-color: rgb(233,249,238);
  border: 1px solid rgb(221,242,228);
}
</style>
